import axios from 'axios'

export const jwtDefaultConfig = {
  loginEndpoint: '/login',
  registerEndpoint: '/register',
  refreshEndpoint: '/refresh-token',
  logoutEndpoint: '/logout',
  tokenType: 'Bearer',
  storageTokenKeyName: 'TKCCB477BC43E8DFDA8978F88B4A55F',
  storageRefreshTokenKeyName: 'RF6A171F7F7AEB1359AAE9281C5D2A6',
}

export default class JwtService {
  axiosInstance = null;

  subscribers = [];

  jwtConfig = { ...jwtDefaultConfig };

  isAlreadyFetchingAccessToken = false;

  constructor({ axiosIns = axios, jwtOverrideConfig = {} }) {
    this.axiosInstance = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    this.axiosInstance.interceptors.request.use(
      config => {
        const accessToken = this.getToken()

        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    this.axiosInstance.interceptors.response.use(
      response => response,
      error => {
        const { config, response } = error
        const originalRequest = config

        if (response && response.status === 401) {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            this.refreshToken().then(rsp => {
              this.isAlreadyFetchingAccessToken = false
              this.setToken(rsp.data.token)
              this.setRefreshToken(rsp.data.refreshToken)
              this.onAccessTokenFetched(rsp.data.token)
            })
          }
          return new Promise(resolve => {
            this.addSubscriber(accessToken => {
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
              resolve(this.axiosInstance(originalRequest))
            })
          })
        }
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  removeToken() {
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosInstance.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosInstance.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosInstance.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}

export const jwtService = new JwtService({})
